<template>
	<div class="message-class">
		<div class="qunabuyi" @click="ReadyAll">全部已读</div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane v-for="(item,index) in messageTabsList" :label="item.label" :name="item.value" :key="item.label">
			</el-tab-pane>
		</el-tabs>
		<item-message :tabItem='tabItem' :key='activeName'></item-message>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapState,
		mapActions
	} from 'vuex'
	import itemMessage from './components/item-message.vue'
	export default {
		components: {
			'item-message': itemMessage
		},
		data() {
			return {
				messageTabsList: [
					// {
					// 	label: '全部消息',
					// 	value: 'total',
					// 	num: 0,
					// 	index: 0
					// },
					{
						label: '平台公告',
						value: 'platform',
						messageLabel: '【平台公告】', // 信息标签
						num: 100,
						index: 1
					},
					// {
					// 	label: '审核通知',
					// 	value: 'audit',
					//  messageLabel: '【审核通知】',
					// 	num: 518,
					// 	index: 2
					// }
					{
						label: '退款通知',
						value: 'refund',
						messageLabel: '【退款通知】',
						noDetail: true, // 点击不进入详情页
						// num: 100, // 这个参数不知道是啥
						index: 3 // 请求体中的mtype,暂时放一个3
					},
				],
				activeName: 'platform',
			}
		},
		created() {
			this.initDataFn()
			// this.getMessageData()
		},
		computed: {
			// ...mapState('message', ['messageIndex']),
			tabItem(){
				return this.messageTabsList.find(item=> item.value == this.activeName)
			}
		},
		methods: {
			...mapActions('message', ['messageReadyAll','messageUnreadyNumber']),
			// 初始化数据 messageTabsList
			initDataFn(){
				if(this.staticPath!='/'){ // 只有抖音才展示‘退款通知’tab
					let refundIndex = this.messageTabsList.findIndex(item=> item.value=='refund')
					this.messageTabsList.splice(refundIndex,1)
				}
			},
			handleClick(tab, event) {
				
			},
			
			async ReadyAll(){
			 	await this.messageReadyAll()
				this.messageUnreadyNumber()
				let temp = this.activeName
				this.activeName=''
				setTimeout(()=>{
					this.activeName=temp
				},10)
			}
		}
	}
</script>
<style lang="less" scoped>
	.message-class{
		position: relative;
		.qunabuyi{
			position: absolute;
			z-index: 9;
			top: 5px;
			right: 0px;
			color: #D9001B;
			font-size: 14px;
			cursor:pointer;
		}
	}
	.message-list {
		width: 925px;
		min-height: 200px;
		border-radius: 4px;
		border: 1px solid rgba(215, 215, 215, 1);
		padding: 10px;
	}

	.message-item {
		height: 79px;
		background-color: rgba(245, 247, 250, 1);
		padding: 5px;
		box-sizing: border-box;
		font-size: 13px;
		margin-top: 10px;

		.small-text {
			font-weight: 400;
			color: #555555;
			padding-left: 70px;
			line-height: 20px;
		}
	}
</style>
